<template>
  <div :class="['product-insurance-li', {'selected': active}]">
    <div class="hot-recommend" v-if="plan.is_default">{{tag}}</div>
    <div class="plan-name" :title="plan.insurance_name">
      {{ plan.insurance_name }}
    </div>
    <div class="plan-series">{{ plan.plan_name }}</div>
    <div class="plan-demand">
      <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/icon_demand.png" alt="" />
      <div class="text"  :title="`最高理赔${ plan.max_claim / 1000000 }万元`">最高理赔<span class="highlight-text">{{ plan.max_claim / 1000000 }}万</span>元</div>
    </div>
    <div class="plan-demand">
      <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/icon_demand.png" alt="" />
      <div class="text" :title="`最长保障${ plan.max_protect_days}天`">最长保障<span class="highlight-text">{{ plan.max_protect_days }}</span>天</div>
    </div>

    <div class="plan-footer">
      <div class="original-price" v-if="active && originalSingleFee !== undefined">
        保单价
        <span class="price">￥{{originalSingleFee / 100}}</span>
      </div>
      <!-- 选中状态下，显示实际的保险价格 -->
      <div class="plan-price" v-if="active && singleFee !== undefined">
        <base-price-text
          :price="singleFee"
          :styleOption="{
            currency: 'font-size: 16px;line-height:18px;margin-right: 2px;',
            integer: 'font-size: 26px;line-height:24px;',
            decimal: 'font-size: 20px;',
          }"
        >
          <template #right><span
            style="font-size: 14px;line-height:18px;margin-left: 2px;font-weight: 400;"
          >/人</span></template>
        </base-price-text>
      </div>

      <div class="plan-price is-gray" v-else>
        <base-price-text
          :color="active ? '#FF5900' : '#2E333E'"
          :price="plan.min_fee"
          :styleOption="{
            currency: 'font-size: 16px;line-height:18px;margin-right: 2px;',
            integer: 'font-size: 26px;line-height:24px;',
            decimal: 'font-size: 20px;',
          }"
        >
          <template #right><span
            style="font-size: 14px;line-height:18px;margin-left: 2px;font-weight: 400;"
          >起</span></template>
        </base-price-text>
      </div>
    </div>
    
    <img
      class="selected-icon"
      src="https://o.666visa.cn/static/ssqpeer/order/icon_selected.png"
      alt=""
    />
  </div>
</template>
<script>
import BasePriceText from './base/base-price-text.vue';

export default {
  components: {
    BasePriceText,
  },
  props: {
    plan: {
      type: Object,
      default: () => {},
    },
    
    active: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: '80%用户选择',
    },

    originalSingleFee: Number,
    singleFee: Number,
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.product-insurance-li {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 165px;
  height: 214px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  padding: 28px 16px 16px;
  position: relative;
  color: #2f333d;
  .hot-recommend {
    display: block;
    position: absolute;
    left: -2px;
    top: -10px;
    width: 91px;
    height: 20px;
    line-height: 20px;
    background: url(https://o.666visa.cn/static/ssqpeer/order/hot_recommend_bg.png)
      center no-repeat;
    background-size: cover;
    font-size: 12px;
    color: #fff;
    text-align: center;
    font-weight: 500;
    padding: 0 2px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .plan-name,
  .plan-series {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .plan-name {
    flex-shrink: 0;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  }
  .plan-series {
    flex-shrink: 0;
    font-size: 16px;
    font-weight: 400;
    box-sizing: content-box;
    height: 16px;
    padding: 8px 0 16px;
  }
  .plan-demand {
    flex-shrink: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;
    &:last-of-type{
      margin-bottom: 0;
    }
    .icon {
      display: block;
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
    .text {
      font-size: 14px;
      color: #666;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .highlight-text {
        color: #ff5900;
      }
    }
  }
  .plan-footer{
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    .original-price{
      font-size: 12px;
      color: #91999F;
      margin-bottom: 4px;
      .price{
        text-decoration: line-through;
      }
    }

  }
  .selected-icon {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 34px;
    height: 34px;
    display: none;
  }
}
&:hover {
  cursor: pointer;
}
.selected {
  background: rgba(255, 223, 191, 0.2);
  border-color: #ff5900;
  .selected-icon {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-insurance-plan.vue